import { graphql } from 'react-apollo'
import { compose, withProps, lifecycle } from 'recompose'

import withLocalization from './withLocalization'
import withFlattenedTranslations from './withFlattenedTranslations'
import withLoadingState from './withLoadingState'
import withErrorState from './withErrorState'
import withNewsStatus from './withNewsStatus'
import withConnectionStatus from './withConnectionStatus'

import newsQuery from '../queries/news'

const POLL_INTERVAL = 60000 // 1 minute

const buildQueryOptions = ({
  language,
  fetchPolicy,
  newsSize,
  newsSkip,
  newsReadTimestamp,
  stage
}) => {
  return {
    variables: {
      lang: language.toLowerCase(),
      first: newsSize,
      skip: newsSkip,
      stage,
      lastRead: new Date(newsReadTimestamp).toISOString(),
      now: new Date().toISOString()
    },
    fetchPolicy
  }
}

export default customLoadingComponent =>
  compose(
    withConnectionStatus,
    withLocalization,
    withNewsStatus,
    lifecycle({
      componentDidMount() {
        this.refetchInterval = setInterval(() => {
          if (this.props.connectionStatus === 'online') {
            this.setState({})
          }
        }, POLL_INTERVAL)
      },
      componentWillUnmount() {
        clearInterval(this.refetchInterval)
      }
    }),
    graphql(newsQuery, {
      options: props => {
        return buildQueryOptions(props)
      }
    }),
    withErrorState,
    withLoadingState('newses', customLoadingComponent, customLoadingComponent),
    withFlattenedTranslations('newses'),
    withProps(({ newses, data, newsReadTimestamp }) => {
      if (newses) {
        const news = newses.map(newsItem => {
          const { publicationDate } = newsItem

          const publicationTimestamp = Date.parse(publicationDate)

          return {
            ...newsItem,
            isUnread: publicationTimestamp > newsReadTimestamp
          }
        })

        const unreadNewsCount = data.unreadNews.aggregate.count
        const totalNewsCount = data.totalNews.aggregate.count

        return { news, unreadNewsCount, totalNewsCount }
      }
      return { news: [], unreadNewsCount: 0 }
    })
  )



// WEBPACK FOOTER //
// ./src/hocs/withNews.js